import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "./Grant.css"; // Import the CSS file
import Navbar from "../../Components/Navbar";
import Navbar2 from "../../Components/Navbar2";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { useForm } from "./MainForm"; // Import useForm from FormContext
import axios from "axios"; // Import axios for HTTP requests
import Popup from "../../Components/Popup";
import { API_BASE_URL } from "../../config";

export default function Grant() {
  const {
    formData,
    handleFormDataChange,
    resetFormData,
    updateCompletionStatus,
  } = useForm();
  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false); // Track form submission
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSubmissionOpen, setIsSubmissionOpen] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormDataChange({ [name]: value });
  };

  // Validation function to check required fields
  const validate = () => {
    let errors = {};

    if (!formData.reviewer1Name)
      errors.reviewer1Name = "Reviewer 1 Name is required.";
    if (!formData.reviewer2Name)
      errors.reviewer2Name = "Reviewer 2 Name is required.";
    if (!formData.reviewer3Name)
      errors.reviewer3Name = "Reviewer 3 Name is required.";
    if (!formData.reviewer1Email)
      errors.reviewer1Email = "Reviewer 1 Email is required.";
    if (!formData.reviewer2Email)
      errors.reviewer2Email = "Reviewer 2 Email is required.";
    if (!formData.reviewer3Email)
      errors.reviewer3Email = "Reviewer 3 Email is required.";
    if (!formData.reviewer1Affiliation)
      errors.reviewer1Affiliation = "Reviewer 1 Affiliation is required.";
    if (!formData.reviewer2Affiliation)
      errors.reviewer2Affiliation = "Reviewer 2 Affiliation is required.";
    if (!formData.reviewer3Affiliation)
      errors.reviewer3Affiliation = "Reviewer 3 Affiliation is required.";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Function to Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Run validation first
    const isValid = validate();

    if (!isValid) {
      // Generate a list of missing fields if validation fails
      const missingFields = Object.keys(formErrors)
        .map((key) => {
          const fieldLabel = key.replace(/([A-Z])/g, " $1").trim(); // Convert camelCase to space-separated
          return fieldLabel;
        })
        .join(", ");

      // Display an alert with the missing fields
      window.alert(`Missing Required Fields: ${missingFields}`);
      setSubmitted(false); // Ensure not submitted if validation fails
      return; // Exit the function early to prevent submission
    }

    // Proceed with form submission if validation passes
    try {
      const response = await axios.post(`${API_BASE_URL}/Grant.php`, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          (data) => {
            const params = new URLSearchParams();
            for (const key in data) {
              params.append(key, data[key]);
            }
            return params;
          },
        ],
      });

      console.log(response.data); // Log the response for debugging

      if (response.data.status === "success") {
        setSubmitted(true); // Set form as submitted only on success
        window.alert(response.data.message);

        // Clear form data and local storage
        localStorage.removeItem("formData");
        resetFormData(); // Reset formData to initial state
      } else {
        window.alert("Form submission failed. Please try again.");
      }
    } catch (error) {
      console.error("There was an error submitting the form:", error);
      window.alert("There was an error submitting the form. Please try again.");
    }
  };

  // Function to navigate to the next page
  const handlePrevious = () => {
    navigate("/uploads"); // Navigate to the previous page
  };

  const handleSave = async () => {
    if (isSubmitted) {
      alert("Form data has already been saved.");
      return; // Prevent further submissions
    }

    try {
      // Step 1: Save the form data
      const response = await axios.post(
        `${API_BASE_URL}/SaveForm.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          transformRequest: [
            (data) => {
              const params = new URLSearchParams();
              for (const key in data) {
                params.append(key, data[key]);
              }
              return params;
            },
          ],
        }
      );

      if (response.data.status === "success") {
        setIsSubmitted(true);
        alert("Form saved successfully.");

        // Step 2: Upload the files
        const fileUploadResponse = await axios.post(
          `${API_BASE_URL}/SaveFileUploads.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(fileUploadResponse.data);

        if (fileUploadResponse.data.status === "success") {
          alert("Files uploaded successfully.");

          // Step 3: Filter out relevant data for MultipleRows.php
          const relevantData = {
            grantRows: formData.grantRows,
            fundingRows: formData.fundingRows,
            co_investigators: formData.co_investigators, // Add the multiple rows for supervisors here
          };

          // Step 4: Submit the filtered data to MultipleRows.php
          const multipleRowsResponse = await axios.post(
            `${API_BASE_URL}/SaveMultipleRows.php`,
            relevantData,
            {
              headers: {
                "Content-Type": "application/json", // Set content type to JSON for MultipleRows.php
              },
            }
          );

          console.log(multipleRowsResponse.data); // Log the response for debugging

          if (multipleRowsResponse.data.status === "success") {
            localStorage.removeItem("formData");
            resetFormData();
            navigate("/submittedgrant"); // Navigate to the submitted grant page
          } else {
            alert(
              "Submission to MultipleRows.php failed: " +
                multipleRowsResponse.data.message
            );
          }
        } else {
          alert(fileUploadResponse.data.message);
        }
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error details:", error);
      alert(
        "There was an error saving the data or uploading files. Please try again."
      );
    }
  };

  const handleFinish = async (e) => {
    e.preventDefault();

    const isValid = validate();

    if (isValid) {
      setLoading(true); // Set loading to true before starting the submission

      try {
        // Step 1: Submit the relevant data to MultipleRows.php to generate app_ID
        const relevantData = {
          granttype:formData.granttype,
          title: formData.title,
          name: formData.name,
          faculty: formData.faculty,
          department: formData.department,
          email: formData.email,
          phone: formData.phone,
          position: formData.position,
          degree: formData.degree,
          university: formData.university,
          year: formData.year,
          field: formData.field,
          Leave_Get: formData.Leave_Get,
          Leave_Date: formData.Leave_Date,
          Leave_Duration: formData.Leave_Duration,
          projectTitle: formData.projectTitle,
          projectInvolved: formData.projectInvolved,
          publication1: formData.publication1,
          publication2: formData.publication2,
          publication3: formData.publication3,
          outsidegrants: formData.outsidegrants,
          researchFacilities: formData.researchFacilities,
          foreign_collaborators: formData.foreign_collaborators,
          foreign_collaborator_departmentUniversity:
            formData.foreign_collaborator_departmentUniversity,
          reviewer1Name: formData.reviewer1Name,
          reviewer2Name: formData.reviewer2Name,
          reviewer3Name: formData.reviewer3Name,
          reviewer1Email: formData.reviewer1Email,
          reviewer2Email: formData.reviewer2Email,
          reviewer3Email: formData.reviewer3Email,
          reviewer1Affiliation: formData.reviewer1Affiliation,
          reviewer2Affiliation: formData.reviewer2Affiliation,
          reviewer3Affiliation: formData.reviewer3Affiliation,
          grantRows: formData.grantRows,
          fundingRows: formData.fundingRows,
          co_investigators: formData.co_investigators,
        };

        const multipleRowsResponse = await axios.post(
          `${API_BASE_URL}/MultipleRows.php`,
          relevantData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (
          multipleRowsResponse.data &&
          multipleRowsResponse.data.status === "success"
        ) {
          // Step 2: Submit the files to FileUploads.php after app_ID is generated
          const fileUploadResponse = await axios.post(
            `${API_BASE_URL}/FileUploads.php`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (fileUploadResponse.data.status === "success") {
            if (multipleRowsResponse.data.pdfUrl) {
              window.open(
                `${API_BASE_URL}/${multipleRowsResponse.data.pdfUrl}`,
                "_blank"
              );
            } else {
              alert("Form submitted successfully!");
            }

            navigate("/popup");
            localStorage.removeItem("formData");
            resetFormData();
            setSubmitted(true);
          } else {
            window.alert("File upload failed. Please try again.");
          }
        } else {
          window.alert(
            "Submission to MultipleRows.php failed: " +
              (multipleRowsResponse.data?.message || "Unknown error occurred.")
          );
        }
      } catch (error) {
        console.error("Error during form submission:", error);
        window.alert(
          "There was an error submitting the form. Please try again."
        );
      } finally {
        setLoading(false); // Set loading to false after completion or error
      }
    } else {
      window.alert("Missing required fields.");
    }
  };
  useEffect(() => {
    const checkApplicationWindow = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/ApplicationDates.php`);
        const data = await res.json();

        if (data.status === "success") {
          const now = new Date();
          const open = new Date(data.Open_Date);
          const close = new Date(data.Close_Date);
          setIsSubmissionOpen(now >= open && now <= close);
        } else {
          setIsSubmissionOpen(false);
        }
      } catch (error) {
        console.error("Error checking application window:", error);
        setIsSubmissionOpen(false);
      }
    };

    checkApplicationWindow();
  }, []);

  return (
    <div>
      <Navbar />
      <Navbar2 />
      <Sidebar />

      <div className="form-container">
        {loading && (
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Submitting...</p>
          </div>
        )}

        {submitted && (
          <div className="alert alert-success" role="alert">
            Form submitted successfully!
          </div>
        )}

        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Label>
              *Names & Affiliations of 3 Reviewers of the research proposal
              (preferably from other faculties/outside institutions)
            </Form.Label>

            {/* Reviewer 1 Details */}
            <Col md={4}>
              <Form.Group controlId="formGridReviewer1">
                <Form.Label>
                  {" "}
                  Reviewer 1 <span className="text-danger">*</span>
                </Form.Label>
                <br></br>
                <Form.Label>1. Name</Form.Label>
                <Form.Control
                  name="reviewer1Name"
                  value={formData.reviewer1Name || ""}
                  placeholder="Reviewer 1"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer1Name}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer1Name}
                </Form.Control.Feedback>

                <Form.Label>2. Email</Form.Label>
                <Form.Control
                  name="reviewer1Email"
                  value={formData.reviewer1Email || ""}
                  placeholder="Reviewer 1: Email"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer1Email}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer1Email}
                </Form.Control.Feedback>

                <Form.Label>3. Affiliation (200 Characters Only)</Form.Label>
                <Form.Control
                  name="reviewer1Affiliation"
                  value={formData.reviewer1Affiliation || ""}
                  placeholder="Reviewer 1: Affiliation"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer1Affiliation}
                  maxLength={200} // Limit characters to 200
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer1Affiliation}
                </Form.Control.Feedback>
                <div className="text-muted" style={{ fontSize: "0.875rem" }}>
                  {formData.reviewer1Affiliation
                    ? formData.reviewer1Affiliation.length
                    : 0}{" "}
                  / 200
                </div>
              </Form.Group>
            </Col>

            {/* Reviewer 2 Details */}
            <Col md={4}>
              <Form.Group controlId="formGridReviewer2">
                <Form.Label>
                  Reviewer 2 <span className="text-danger">*</span>
                </Form.Label>
                <br></br>
                <Form.Label>1. Name</Form.Label>
                <Form.Control
                  name="reviewer2Name"
                  value={formData.reviewer2Name || ""}
                  placeholder="Reviewer 2"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer2Name}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer2Name}
                </Form.Control.Feedback>

                <Form.Label>2. Email</Form.Label>
                <Form.Control
                  name="reviewer2Email"
                  value={formData.reviewer2Email || ""}
                  placeholder="Reviewer 2: Email"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer2Email}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer2Email}
                </Form.Control.Feedback>

                <Form.Label>3. Affiliation (200 Characters Only) </Form.Label>

                <Form.Control
                  name="reviewer2Affiliation"
                  value={formData.reviewer2Affiliation || ""}
                  placeholder="Reviewer 2: Affiliation"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer2Affiliation}
                  maxLength={200} // Limit characters to 200
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer2Affiliation}
                </Form.Control.Feedback>
                <div className="text-muted" style={{ fontSize: "0.875rem" }}>
                  {formData.reviewer2Affiliation
                    ? formData.reviewer2Affiliation.length
                    : 0}{" "}
                  / 200
                </div>
              </Form.Group>
            </Col>

            {/* Reviewer 3 Details */}
            <Col md={4}>
              <Form.Group controlId="formGridReviewer3">
                <Form.Label>
                  Reviewer 3 <span className="text-danger">*</span>
                </Form.Label>
                <br></br>
                <Form.Label>1. Name</Form.Label>
                <Form.Control
                  name="reviewer3Name"
                  value={formData.reviewer3Name || ""}
                  placeholder="Reviewer 3"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer3Name}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer3Name}
                </Form.Control.Feedback>

                <Form.Label>2. Email</Form.Label>
                <Form.Control
                  name="reviewer3Email"
                  value={formData.reviewer3Email || ""}
                  placeholder="Reviewer 3: Email"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer3Email}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer3Email}
                </Form.Control.Feedback>

                <Form.Label>3. Affiliation (200 Characters Only) </Form.Label>

                <Form.Control
                  name="reviewer3Affiliation"
                  value={formData.reviewer3Affiliation || ""}
                  placeholder="Reviewer 3: Affiliation"
                  className="form-control"
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.reviewer3Affiliation}
                  maxLength={200} // Limit characters to 200
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.reviewer3Affiliation}
                </Form.Control.Feedback>
                <div className="text-muted" style={{ fontSize: "0.875rem" }}>
                  {formData.reviewer3Affiliation
                    ? formData.reviewer3Affiliation.length
                    : 0}{" "}
                  / 200
                </div>
              </Form.Group>
            </Col>
          </Row>

          <div className="form-buttons">
            {/* <Button variant="secondary" onClick={handleSave} className='savebutton'>
      Save
    </Button> */}
            <Button
              variant="secondary"
              onClick={handlePrevious}
              className="previousbutton"
            >
              Previous
            </Button>
            {isSubmissionOpen && (
              <Button
                variant="primary"
                type="submit"
                onClick={handleFinish}
                className="nextbutton"
              >
                Finish and Submit
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
}
